import React, { MouseEventHandler } from "react";
import styles from "./styles.module.css";

interface Props extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "ref"> {
  icon: JSX.Element;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  title?: string;
}
export const ControlBtn = React.forwardRef<HTMLButtonElement, Props>(
  ({ icon, onClick, disabled, title, ...rest }, ref) => {
    return (
      <div className={styles.container}>
        <button onClick={onClick} disabled={disabled ?? false} title={title} ref={ref} {...rest}>
          {icon}
        </button>
      </div>
    );
  }
);
